export enum MatchTeamOutcomeModelTypeEnum {
  Match = "MATCH",
  SeasonGroup = "SEASON_GROUP",
}
